import PriceRating from './PriceRating';

export default PriceRating;
